"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _miniDealerLocator = _interopRequireDefault(require("./mini-dealer-locator.css"));
var ListToggle = function ListToggle(_ref) {
  var theme = _ref.theme,
    mobileShowMap = _ref.mobileShowMap,
    updateMobileShowMap = _ref.updateMobileShowMap,
    listLabel = _ref.listLabel,
    mapLabel = _ref.mapLabel;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _miniDealerLocator["default"].listToggleButtons
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: theme.inputsAndOptions + " " + _miniDealerLocator["default"].toggleDefault + " " + (!mobileShowMap ? _miniDealerLocator["default"].toggleSelected : ''),
    onClick: function onClick() {
      return updateMobileShowMap(false);
    }
  }, listLabel), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: theme.inputsAndOptions + " " + _miniDealerLocator["default"].toggleDefault + " " + (!mobileShowMap ? '' : _miniDealerLocator["default"].toggleSelected),
    onClick: function onClick() {
      return updateMobileShowMap(true);
    }
  }, mapLabel));
};
var _default = ListToggle;
exports["default"] = _default;